//import React, { useEffect, useRef } from "react";
import React, { useRef, useEffect } from "react";
import { Container } from "./styles";
import { ReactComponent as BtnArrow } from "assets/arrowbtn.svg";
import ellipse13 from "assets/ellipse13.png";
import LineWand from "component/LineWand";
// import { gsap } from "gsap";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
function Index({
  header_tip,
  header,
  desc,
  btnText,
  img,
  imgStart,
  bg,
  showLine,
  imgContentZIndex,
  btnLink,
  ...props
}) {
  const textContentRef = useRef(null);
  const imgContentRef = useRef(null);

  useEffect(() => {
    // gsap.from(textContentRef.current, {
    //   x: 100,
    //   duration: 1,
    //   opacity: 0,
    //   delay: 0.5,
    //   scrollTrigger: {
    //     trigger: textContentRef.current,
    //     toggleActions: "play none none reverse"
    //   }
    // });
    // gsap.from(imgContentRef.current, {
    //   x: -100,
    //   duration: 1,
    //   opacity: 0,
    //   delay: 0.5,
    //   scrollTrigger: {
    //     trigger: imgContentRef.current,
    //     toggleActions: "play none none reverse"
    //   }
    // });
    AOS.init();
  }, []);
  return (
    <Container background={bg} imgStart={imgStart} zIndex={imgContentZIndex}>
      {showLine && <LineWand zIndex={imgContentZIndex + 1} />}
      {showLine && <img src={ellipse13} className="ellipse" alt="ellipse" />}
      <div className="wrapper" {...props}>
        <div
          className="text-content"
          ref={textContentRef}
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <span>{header_tip}</span>
          <p className="header">{header}</p>
          <p className="desc">{desc}</p>
          {btnText && (
            <button className="more-btn">
              <Link to={btnLink ?? "/"}>
                {btnText} <BtnArrow />
              </Link>
            </button>
          )}
        </div>
        <div className="img-content" ref={imgContentRef} data-aos="fade-up" data-aos-duration="800">
          {img && <img src={img} alt="img" />}
        </div>
      </div>
    </Container>
  );
}

export default Index;
